import { computeZscore } from './utils'
// @ts-expect-error implicit any
// eslint-disable-next-line
function cleanNumber(input) {
  let number = input
  if (typeof input == 'object') {
    number = input.value
  }
  if (!Number.isFinite(number)) {
    return null
  }
  if (Math.abs(number) >= 1000) {
    return parseFloat(number.toFixed(0))
  }
  if (Math.abs(number) >= 100) {
    return parseFloat(number.toFixed(1))
  }
  if (Math.abs(number) >= 10) {
    return parseFloat(number.toFixed(2))
  }
  if (Math.abs(number) >= 1) {
    return parseFloat(number.toFixed(3))
  }
  return parseFloat(number.toPrecision(4))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function cpiAvg(params) {
  let sumSpend = 0
  let sumInstalls = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    sumInstalls += child.data.ua_installs
    sumSpend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(sumSpend / sumInstalls)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function cpmAvg(params) {
  let sumSpend = 0
  let sumImpressions = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    sumSpend += child.data.ua_spend
    sumImpressions += child.data.ua_impressions
  })
  return cleanNumber((sumSpend / sumImpressions) * 1000)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function cvrAvg(params) {
  let sumInstalls = 0
  let sumClicks = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    sumInstalls += child.data.ua_installs
    sumClicks += child.data.ua_clicks
  })
  return cleanNumber(sumInstalls / sumClicks)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function ctrAvg(params) {
  let sumImpressions = 0
  let sumClicks = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    sumImpressions += child.data.ua_impressions
    sumClicks += child.data.ua_clicks
  })
  return cleanNumber(sumClicks / sumImpressions)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function extrapolationAvg(params) {
  let ua_installs = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_installs += child.data.ua_installs
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_installs / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd0Avg(params) {
  let ua_total_pred_d0_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d0_360_eur += child.data.ua_total_pred_d0_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_pred_d0_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd3Avg(params) {
  let ua_total_pred_d3_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d3_360_eur += child.data.ua_total_pred_d3_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(ua_total_pred_d3_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd7Avg(params) {
  let ua_total_pred_d7_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d7_360_eur += child.data.ua_total_pred_d7_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(ua_total_pred_d7_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd10Avg(params) {
  let ua_total_pred_d10_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d10_360_eur += child.data.ua_total_pred_d10_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(ua_total_pred_d10_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd30Avg(params) {
  let ua_total_pred_d30_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d30_360_eur += child.data.ua_total_pred_d30_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(ua_total_pred_d30_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaAdsEltvd30Avg(params) {
  let ua_total_ads_pred_d30_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d30_360_eur += child.data.ua_total_ads_pred_d30_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d30_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaAdsEltvd10Avg(params) {
  let ua_total_ads_pred_d10_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d10_360_eur += child.data.ua_total_ads_pred_d10_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d10_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaAdsEltvd7Avg(params) {
  let ua_total_ads_pred_d7_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d7_360_eur += child.data.ua_total_ads_pred_d7_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d7_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaAdsEltvd3Avg(params) {
  let ua_total_ads_pred_d3_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d3_360_eur += child.data.ua_total_ads_pred_d3_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d3_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaAdsEltvd0Avg(params) {
  let ua_total_ads_pred_d0_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d0_360_eur += child.data.ua_total_ads_pred_d0_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d0_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvSovd0Avg(params) {
  // Compute ua_eltv_d0
  let ua_total_pred_d0_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d0_360_eur += child.data.ua_total_pred_d0_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  const ua_eltv_d0 = cleanNumber(ua_total_pred_d0_360_eur) || 0

  // Compute ua_iap_eltv_d0
  let ua_total_inapps_pred_d0_360_eur = 0
  maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d0_360_eur += child.data.ua_total_inapps_pred_d0_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  const ua_iap_eltv_d0 = cleanNumber(ua_total_inapps_pred_d0_360_eur) || 0

  // Compute ua_iap_eltv_sov_d0
  return cleanNumber(ua_iap_eltv_d0 / ua_eltv_d0)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvSovd3Avg(params) {
  // Compute ua_eltv_d3
  let ua_total_pred_d3_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d3_360_eur += child.data.ua_total_pred_d3_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  const ua_eltv_d3 = cleanNumber(ua_total_pred_d3_360_eur) || 0

  // Compute ua_iap_eltv_d3
  let ua_total_inapps_pred_d3_360_eur = 0
  maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d3_360_eur += child.data.ua_total_inapps_pred_d3_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  const ua_iap_eltv_d3 = cleanNumber(ua_total_inapps_pred_d3_360_eur) || 0

  // Compute ua_iap_eltv_sov_d3
  return cleanNumber(ua_iap_eltv_d3 / ua_eltv_d3)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvSovd7Avg(params) {
  // Compute ua_eltv_d7
  let ua_total_pred_d7_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d7_360_eur += child.data.ua_total_pred_d7_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  const ua_eltv_d7 = cleanNumber(ua_total_pred_d7_360_eur) || 0

  // Compute ua_iap_eltv_d7
  let ua_total_inapps_pred_d7_360_eur = 0
  maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d7_360_eur += child.data.ua_total_inapps_pred_d7_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  const ua_iap_eltv_d7 = cleanNumber(ua_total_inapps_pred_d7_360_eur) || 0

  // Compute ua_iap_eltv_sov_d7
  return cleanNumber(ua_iap_eltv_d7 / ua_eltv_d7)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvSovd10Avg(params) {
  // Compute ua_eltv_d10
  let ua_total_pred_d10_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d10_360_eur += child.data.ua_total_pred_d10_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  const ua_eltv_d10 = cleanNumber(ua_total_pred_d10_360_eur) || 0

  // Compute ua_iap_eltv_d10
  let ua_total_inapps_pred_d10_360_eur = 0
  maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d10_360_eur += child.data.ua_total_inapps_pred_d10_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  const ua_iap_eltv_d10 = cleanNumber(ua_total_inapps_pred_d10_360_eur) || 0

  // Compute ua_iap_eltv_sov_d10
  return cleanNumber(ua_iap_eltv_d10 / ua_eltv_d10)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvSovd30Avg(params) {
  // Compute ua_eltv_d30
  let ua_total_pred_d30_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d30_360_eur += child.data.ua_total_pred_d30_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  const ua_eltv_d30 = cleanNumber(ua_total_pred_d30_360_eur) || 0

  // Compute ua_iap_eltv_d30
  let ua_total_inapps_pred_d30_360_eur = 0
  maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d30_360_eur += child.data.ua_total_inapps_pred_d30_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  const ua_iap_eltv_d30 = cleanNumber(ua_total_inapps_pred_d30_360_eur) || 0

  // Compute ua_iap_eltv_sov_d30
  return cleanNumber(ua_iap_eltv_d30 / ua_eltv_d30)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvd0Avg(params) {
  let ua_total_inapps_pred_d0_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d0_360_eur += child.data.ua_total_inapps_pred_d0_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d0_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvd3Avg(params) {
  let ua_total_inapps_pred_d3_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d3_360_eur += child.data.ua_total_inapps_pred_d3_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d3_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvd7Avg(params) {
  let ua_total_inapps_pred_d7_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d7_360_eur += child.data.ua_total_inapps_pred_d7_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d7_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvd10Avg(params) {
  let ua_total_inapps_pred_d10_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d10_360_eur += child.data.ua_total_inapps_pred_d10_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d10_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaIapEltvd30Avg(params) {
  let ua_total_inapps_pred_d30_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d30_360_eur += child.data.ua_total_inapps_pred_d30_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d30_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvd0Avg(params) {
  let mwm_total_pred_d0_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d0_360_eur += child.data.mwm_total_pred_d0_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_total_pred_d0_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvd3Avg(params) {
  let mwm_total_pred_d3_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d3_360_eur += child.data.mwm_total_pred_d3_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(mwm_total_pred_d3_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvd7Avg(params) {
  let mwm_total_pred_d7_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d7_360_eur += child.data.mwm_total_pred_d7_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(mwm_total_pred_d7_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvd10Avg(params) {
  let mwm_total_pred_d10_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d10_360_eur += child.data.mwm_total_pred_d10_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_total_pred_d10_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvd30Avg(params) {
  let mwm_total_pred_d30_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d30_360_eur += child.data.mwm_total_pred_d30_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(mwm_total_pred_d30_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapEltvd0Avg(params) {
  let mwm_total_inapps_pred_d0_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_inapps_pred_d0_360_eur += child.data.mwm_total_inapps_pred_d0_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_total_inapps_pred_d0_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapEltvd3Avg(params) {
  let mwm_total_inapps_pred_d3_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_inapps_pred_d3_360_eur += child.data.mwm_total_inapps_pred_d3_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(mwm_total_inapps_pred_d3_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapEltvd7Avg(params) {
  let mwm_total_inapps_pred_d7_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_inapps_pred_d7_360_eur += child.data.mwm_total_inapps_pred_d7_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(mwm_total_inapps_pred_d7_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapEltvd10Avg(params) {
  let mwm_total_inapps_pred_d10_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_inapps_pred_d10_360_eur += child.data.mwm_total_inapps_pred_d10_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_total_inapps_pred_d10_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapEltvd30Avg(params) {
  let mwm_total_inapps_pred_d30_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_inapps_pred_d30_360_eur += child.data.mwm_total_inapps_pred_d30_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(mwm_total_inapps_pred_d30_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsEltvd0Avg(params) {
  let mwm_total_ads_pred_d0_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_ads_pred_d0_360_eur += child.data.mwm_total_ads_pred_d0_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_total_ads_pred_d0_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsEltvd3Avg(params) {
  let mwm_total_ads_pred_d3_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_ads_pred_d3_360_eur += child.data.mwm_total_ads_pred_d3_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(mwm_total_ads_pred_d3_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsEltvd7Avg(params) {
  let mwm_total_ads_pred_d7_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_ads_pred_d7_360_eur += child.data.mwm_total_ads_pred_d7_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(mwm_total_ads_pred_d7_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsEltvd10Avg(params) {
  let mwm_total_ads_pred_d10_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_ads_pred_d10_360_eur += child.data.mwm_total_ads_pred_d10_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_total_ads_pred_d10_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsEltvd30Avg(params) {
  let mwm_total_ads_pred_d30_360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_ads_pred_d30_360_eur += child.data.mwm_total_ads_pred_d30_360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(mwm_total_ads_pred_d30_360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvPerFreeTriald10Avg(params) {
  let mwm_total_pred_d10_360_eur = 0
  let mwm_nbu_free_trial_d360 = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d10_360_eur += child.data.mwm_total_pred_d10_360_eur
    mwm_nbu_free_trial_d360 += child.data.mwm_nbu_free_trial_d360
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_total_pred_d10_360_eur / mwm_nbu_free_trial_d360)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvPerSubscriberd10Avg(params) {
  let mwm_total_pred_d10_360_eur = 0
  let mwm_nbu_subscriber_d360 = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d10_360_eur += child.data.mwm_total_pred_d10_360_eur
    mwm_nbu_subscriber_d360 += child.data.mwm_nbu_subscriber_d360
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_total_pred_d10_360_eur / mwm_nbu_subscriber_d360)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmEltvPerPayingd10Avg(params) {
  let mwm_total_pred_d10_360_eur = 0
  let mwm_nbu_paying_user_d360 = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_total_pred_d10_360_eur += child.data.mwm_total_pred_d10_360_eur
    mwm_nbu_paying_user_d360 += child.data.mwm_nbu_paying_user_d360
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_total_pred_d10_360_eur / mwm_nbu_paying_user_d360)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEroipercentd0Avg(params) {
  let ua_total_pred_d0_360_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d0_360_eur += child.data.ua_total_pred_d0_360_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_pred_d0_360_eur / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEroipercentd3Avg(params) {
  let ua_total_pred_d3_360_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d3_360_eur += child.data.ua_total_pred_d3_360_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(ua_total_pred_d3_360_eur / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEroipercentd7Avg(params) {
  let ua_total_pred_d7_360_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d7_360_eur += child.data.ua_total_pred_d7_360_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(ua_total_pred_d7_360_eur / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEroipercentd10Avg(params) {
  let ua_total_pred_d10_360_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d10_360_eur += child.data.ua_total_pred_d10_360_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(ua_total_pred_d10_360_eur / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEroipercentd30Avg(params) {
  let ua_total_pred_d30_360_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d30_360_eur += child.data.ua_total_pred_d30_360_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(ua_total_pred_d30_360_eur / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmroipercentAvg(params) {
  let mwm_ads_revenue_total_eur = 0
  let mwm_inapps_revenue_total_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_total_eur += child.data.mwm_ads_revenue_total_eur
    mwm_inapps_revenue_total_eur += child.data.mwm_inapps_revenue_total_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_total_eur + mwm_inapps_revenue_total_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaroipercentAvg(params) {
  let ua_total_revenue_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_revenue_eur += child.data.ua_total_revenue_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_revenue_eur / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpuAvg(params) {
  let mwm_ads_revenue_total_eur = 0
  let mwm_inapps_revenue_total_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_total_eur += child.data.mwm_ads_revenue_total_eur
    mwm_inapps_revenue_total_eur += child.data.mwm_inapps_revenue_total_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_total_eur + mwm_inapps_revenue_total_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud0Avg(params) {
  let mwm_ads_revenue_d0_eur = 0
  let mwm_inapps_revenue_d0_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d0_eur += child.data.mwm_ads_revenue_d0_eur
    mwm_inapps_revenue_d0_eur += child.data.mwm_inapps_revenue_d0_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d0_eur + mwm_inapps_revenue_d0_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud1Avg(params) {
  let mwm_ads_revenue_d1_eur = 0
  let mwm_inapps_revenue_d1_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d1_eur += child.data.mwm_ads_revenue_d1_eur
    mwm_inapps_revenue_d1_eur += child.data.mwm_inapps_revenue_d1_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 2) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d1_eur + mwm_inapps_revenue_d1_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud3Avg(params) {
  let mwm_ads_revenue_d3_eur = 0
  let mwm_inapps_revenue_d3_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d3_eur += child.data.mwm_ads_revenue_d3_eur
    mwm_inapps_revenue_d3_eur += child.data.mwm_inapps_revenue_d3_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d3_eur + mwm_inapps_revenue_d3_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud7Avg(params) {
  let mwm_ads_revenue_d7_eur = 0
  let mwm_inapps_revenue_d7_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d7_eur += child.data.mwm_ads_revenue_d7_eur
    mwm_inapps_revenue_d7_eur += child.data.mwm_inapps_revenue_d7_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d7_eur + mwm_inapps_revenue_d7_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud10Avg(params) {
  let mwm_ads_revenue_d10_eur = 0
  let mwm_inapps_revenue_d10_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d10_eur += child.data.mwm_ads_revenue_d10_eur
    mwm_inapps_revenue_d10_eur += child.data.mwm_inapps_revenue_d10_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d10_eur + mwm_inapps_revenue_d10_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud30Avg(params) {
  let mwm_ads_revenue_d30_eur = 0
  let mwm_inapps_revenue_d30_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d30_eur += child.data.mwm_ads_revenue_d30_eur
    mwm_inapps_revenue_d30_eur += child.data.mwm_inapps_revenue_d30_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d30_eur + mwm_inapps_revenue_d30_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud180Avg(params) {
  let mwm_ads_revenue_d180_eur = 0
  let mwm_inapps_revenue_d180_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d180_eur += child.data.mwm_ads_revenue_d180_eur
    mwm_inapps_revenue_d180_eur += child.data.mwm_inapps_revenue_d180_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 181) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d180_eur + mwm_inapps_revenue_d180_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmArpud360Avg(params) {
  let mwm_ads_revenue_d360_eur = 0
  let mwm_inapps_revenue_d360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d360_eur += child.data.mwm_ads_revenue_d360_eur
    mwm_inapps_revenue_d360_eur += child.data.mwm_inapps_revenue_d360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 366) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d360_eur + mwm_inapps_revenue_d360_eur) / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud0Avg(params) {
  let mwm_inapps_revenue_d0_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d0_eur += child.data.mwm_inapps_revenue_d0_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d0_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud1Avg(params) {
  let mwm_inapps_revenue_d1_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d1_eur += child.data.mwm_inapps_revenue_d1_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d1_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud3Avg(params) {
  let mwm_inapps_revenue_d3_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d3_eur += child.data.mwm_inapps_revenue_d3_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d3_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud7Avg(params) {
  let mwm_inapps_revenue_d7_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d7_eur += child.data.mwm_inapps_revenue_d7_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d7_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud10Avg(params) {
  let mwm_inapps_revenue_d10_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d10_eur += child.data.mwm_inapps_revenue_d10_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d10_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud30Avg(params) {
  let mwm_inapps_revenue_d30_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d30_eur += child.data.mwm_inapps_revenue_d30_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d30_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud180Avg(params) {
  let mwm_inapps_revenue_d180_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d180_eur += child.data.mwm_inapps_revenue_d180_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 181) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d180_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpud360Avg(params) {
  let mwm_inapps_revenue_d360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_d360_eur += child.data.mwm_inapps_revenue_d360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 361) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_d360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmIapArpudTotalAvg(params) {
  let mwm_inapps_revenue_total_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_inapps_revenue_total_eur += child.data.mwm_inapps_revenue_total_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_inapps_revenue_total_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud0Avg(params) {
  let mwm_ads_revenue_d0_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d0_eur += child.data.mwm_ads_revenue_d0_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d0_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud1Avg(params) {
  let mwm_ads_revenue_d1_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d1_eur += child.data.mwm_ads_revenue_d1_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d1_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud3Avg(params) {
  let mwm_ads_revenue_d3_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d3_eur += child.data.mwm_ads_revenue_d3_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d3_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud7Avg(params) {
  let mwm_ads_revenue_d7_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d7_eur += child.data.mwm_ads_revenue_d7_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d7_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud10Avg(params) {
  let mwm_ads_revenue_d10_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d10_eur += child.data.mwm_ads_revenue_d10_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d10_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud30Avg(params) {
  let mwm_ads_revenue_d30_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d30_eur += child.data.mwm_ads_revenue_d30_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d30_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud180Avg(params) {
  let mwm_ads_revenue_d180_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d180_eur += child.data.mwm_ads_revenue_d180_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 181) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d180_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpud360Avg(params) {
  let mwm_ads_revenue_d360_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d360_eur += child.data.mwm_ads_revenue_d360_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 361) {
    return null
  }
  return cleanNumber(mwm_ads_revenue_d360_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmAdsArpudTotalAvg(params) {
  let mwm_ads_revenue_total_eur = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_total_eur += child.data.mwm_ads_revenue_total_eur
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })

  return cleanNumber(mwm_ads_revenue_total_eur / mwm_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerFreeTrialLifetimeAvg(params) {
  let mwm_nbu_free_trial_d360 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_free_trial_d360 += child.data.mwm_nbu_free_trial_d360
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
  })
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_free_trial_d360, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerFreeTrialD0Avg(params) {
  let mwm_nbu_free_trial_d0 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_free_trial_d0 += child.data.mwm_nbu_free_trial_d0
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_free_trial_d0, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerFreeTrialD10Avg(params) {
  let mwm_nbu_free_trial_d10 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_free_trial_d10 += child.data.mwm_nbu_free_trial_d10
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_free_trial_d10, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerPayingUserLifetimeAvg(params) {
  let mwm_nbu_paying_user_d360 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_paying_user_d360 += child.data.mwm_nbu_paying_user_d360
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
  })
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_paying_user_d360, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerPayingUserD0Avg(params) {
  let mwm_nbu_paying_user_d0 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_paying_user_d0 += child.data.mwm_nbu_paying_user_d0
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_paying_user_d0, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerPayingUserD10Avg(params) {
  let mwm_nbu_paying_user_d10 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_paying_user_d10 += child.data.mwm_nbu_paying_user_d10
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_paying_user_d10, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerSubscriberLifetimeAvg(params) {
  let mwm_nbu_subscriber_d360 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_subscriber_d360 += child.data.mwm_nbu_subscriber_d360
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
  })
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_subscriber_d360, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerSubscriberD0Avg(params) {
  let mwm_nbu_subscriber_d0 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_subscriber_d0 += child.data.mwm_nbu_subscriber_d0
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_subscriber_d0, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function costPerSubscriberD10Avg(params) {
  let mwm_nbu_subscriber_d10 = 0
  let ua_installs = 0
  let ua_spend = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_subscriber_d10 += child.data.mwm_nbu_subscriber_d10
    mwm_installs += child.data.mwm_installs
    ua_installs += child.data.ua_installs
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((ua_spend * mwm_installs) / ua_installs / Math.max(mwm_nbu_subscriber_d10, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function revenuePerFreeTrialLifetimeAvg(params) {
  let mwm_nbu_free_trial_d360 = 0
  let mwm_inapps_revenue_d360_eur = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_free_trial_d360 += child.data.mwm_nbu_free_trial_d360
    mwm_inapps_revenue_d360_eur += child.data.mwm_inapps_revenue_d360_eur
  })
  return cleanNumber(mwm_inapps_revenue_d360_eur / Math.max(mwm_nbu_free_trial_d360, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function revenuePerPayingUserLifetimeAvg(params) {
  let mwm_nbu_paying_user_d360 = 0
  let mwm_inapps_revenue_d360_eur = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_paying_user_d360 += child.data.mwm_nbu_paying_user_d360
    mwm_inapps_revenue_d360_eur += child.data.mwm_inapps_revenue_d360_eur
  })
  return cleanNumber(mwm_inapps_revenue_d360_eur / Math.max(mwm_nbu_paying_user_d360, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function revenuePerSubscriberLifetimeAvg(params) {
  let mwm_nbu_subscriber_d360 = 0
  let mwm_inapps_revenue_d360_eur = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_subscriber_d360 += child.data.mwm_nbu_subscriber_d360
    mwm_inapps_revenue_d360_eur += child.data.mwm_inapps_revenue_d360_eur
  })
  return cleanNumber(mwm_inapps_revenue_d360_eur / Math.max(mwm_nbu_subscriber_d360, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function freeTrialPerInstallLifetimeAvg(params) {
  let mwm_nbu_free_trial_d360 = 0
  let mwm_installs = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_free_trial_d360 += child.data.mwm_nbu_free_trial_d360
    mwm_installs += child.data.mwm_installs
  })
  return cleanNumber(mwm_nbu_free_trial_d360 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function freeTrialPerInstallD0Avg(params) {
  let mwm_nbu_free_trial_d0 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_free_trial_d0 += child.data.mwm_nbu_free_trial_d0
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_nbu_free_trial_d0 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function freeTrialPerInstallD10Avg(params) {
  let mwm_nbu_free_trial_d10 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_free_trial_d10 += child.data.mwm_nbu_free_trial_d10
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_nbu_free_trial_d10 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function payingUserPerInstallLifetimeAvg(params) {
  let mwm_nbu_paying_user_d360 = 0
  let mwm_installs = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_paying_user_d360 += child.data.mwm_nbu_paying_user_d360
    mwm_installs += child.data.mwm_installs
  })
  return cleanNumber(mwm_nbu_paying_user_d360 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function payingUserPerInstallD0Avg(params) {
  let mwm_nbu_paying_user_d0 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_paying_user_d0 += child.data.mwm_nbu_paying_user_d0
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_nbu_paying_user_d0 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function payingUserPerInstallD10Avg(params) {
  let mwm_nbu_paying_user_d10 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_paying_user_d10 += child.data.mwm_nbu_paying_user_d10
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_nbu_paying_user_d10 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function subscriberPerInstallLifetimeAvg(params) {
  let mwm_nbu_subscriber_d360 = 0
  let mwm_installs = 0
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_subscriber_d360 += child.data.mwm_nbu_subscriber_d360
    mwm_installs += child.data.mwm_installs
  })
  return cleanNumber(mwm_nbu_subscriber_d360 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function subscriberPerInstallD0Avg(params) {
  let mwm_nbu_subscriber_d0 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_subscriber_d0 += child.data.mwm_nbu_subscriber_d0
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_nbu_subscriber_d0 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function subscriberPerInstallD10Avg(params) {
  let mwm_nbu_subscriber_d10 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_subscriber_d10 += child.data.mwm_nbu_subscriber_d10
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(mwm_nbu_subscriber_d10 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function retentiond1Avg(params) {
  let retention_d1 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    retention_d1 += child.data.retention_d1
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(retention_d1 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function retentiond3Avg(params) {
  let retention_d3 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    retention_d3 += child.data.retention_d3
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(retention_d3 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function retentiond7Avg(params) {
  let retention_d7 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    retention_d7 += child.data.retention_d7
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(retention_d7 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function retentiond30Avg(params) {
  let retention_d30 = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    retention_d30 += child.data.retention_d30
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(retention_d30 / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmOnboardingcompletedAvg(params) {
  let mwm_nbu_onboarding_completed = 0
  let mwm_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_nbu_onboarding_completed += child.data.mwm_nbu_onboarding_completed
    mwm_installs += child.data.mwm_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(mwm_nbu_onboarding_completed / Math.max(mwm_installs, 1))
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmRoipercentd0Avg(params) {
  let mwm_ads_revenue_d0_eur = 0
  let mwm_inapps_revenue_d0_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d0_eur += child.data.mwm_ads_revenue_d0_eur
    mwm_inapps_revenue_d0_eur += child.data.mwm_inapps_revenue_d0_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d0_eur + mwm_inapps_revenue_d0_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmRoipercentd3Avg(params) {
  let mwm_ads_revenue_d3_eur = 0
  let mwm_inapps_revenue_d3_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d3_eur += child.data.mwm_ads_revenue_d3_eur
    mwm_inapps_revenue_d3_eur += child.data.mwm_inapps_revenue_d3_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d3_eur + mwm_inapps_revenue_d3_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmRoipercentd7Avg(params) {
  let mwm_ads_revenue_d7_eur = 0
  let mwm_inapps_revenue_d7_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d7_eur += child.data.mwm_ads_revenue_d7_eur
    mwm_inapps_revenue_d7_eur += child.data.mwm_inapps_revenue_d7_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d7_eur + mwm_inapps_revenue_d7_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmRoipercentd10Avg(params) {
  let mwm_ads_revenue_d10_eur = 0
  let mwm_inapps_revenue_d10_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d10_eur += child.data.mwm_ads_revenue_d10_eur
    mwm_inapps_revenue_d10_eur += child.data.mwm_inapps_revenue_d10_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d10_eur + mwm_inapps_revenue_d10_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmRoipercentd20Avg(params) {
  let mwm_ads_revenue_d20_eur = 0
  let mwm_inapps_revenue_d20_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d20_eur += child.data.mwm_ads_revenue_d20_eur
    mwm_inapps_revenue_d20_eur += child.data.mwm_inapps_revenue_d20_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 21) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d20_eur + mwm_inapps_revenue_d20_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function mwmRoipercentd30Avg(params) {
  let mwm_ads_revenue_d30_eur = 0
  let mwm_inapps_revenue_d30_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    mwm_ads_revenue_d30_eur += child.data.mwm_ads_revenue_d30_eur
    mwm_inapps_revenue_d30_eur += child.data.mwm_inapps_revenue_d30_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber((mwm_ads_revenue_d30_eur + mwm_inapps_revenue_d30_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaRoipercentd0Avg(params) {
  let ua_ads_revenue_d0_eur = 0
  let ua_inapps_revenue_d0_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_ads_revenue_d0_eur += child.data.ua_ads_revenue_d0_eur
    ua_inapps_revenue_d0_eur += child.data.ua_inapps_revenue_d0_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((ua_ads_revenue_d0_eur + ua_inapps_revenue_d0_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaRoipercentd3Avg(params) {
  let ua_ads_revenue_d3_eur = 0
  let ua_inapps_revenue_d3_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_ads_revenue_d3_eur += child.data.ua_ads_revenue_d3_eur
    ua_inapps_revenue_d3_eur += child.data.ua_inapps_revenue_d3_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber((ua_ads_revenue_d3_eur + ua_inapps_revenue_d3_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaRoipercentd7Avg(params) {
  let ua_ads_revenue_d7_eur = 0
  let ua_inapps_revenue_d7_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_ads_revenue_d7_eur += child.data.ua_ads_revenue_d7_eur
    ua_inapps_revenue_d7_eur += child.data.ua_inapps_revenue_d7_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber((ua_ads_revenue_d7_eur + ua_inapps_revenue_d7_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaRoipercentd10Avg(params) {
  let ua_ads_revenue_d10_eur = 0
  let ua_inapps_revenue_d10_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_ads_revenue_d10_eur += child.data.ua_ads_revenue_d10_eur
    ua_inapps_revenue_d10_eur += child.data.ua_inapps_revenue_d10_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((ua_ads_revenue_d10_eur + ua_inapps_revenue_d10_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaRoipercentd20Avg(params) {
  let ua_ads_revenue_d20_eur = 0
  let ua_inapps_revenue_d20_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_ads_revenue_d20_eur += child.data.ua_ads_revenue_d20_eur
    ua_inapps_revenue_d20_eur += child.data.ua_inapps_revenue_d20_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 21) {
    return null
  }
  return cleanNumber((ua_ads_revenue_d20_eur + ua_inapps_revenue_d20_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaRoipercentd30Avg(params) {
  let ua_ads_revenue_d30_eur = 0
  let ua_inapps_revenue_d30_eur = 0
  let ua_spend = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_ads_revenue_d30_eur += child.data.ua_ads_revenue_d30_eur
    ua_inapps_revenue_d30_eur += child.data.ua_inapps_revenue_d30_eur
    ua_spend += child.data.ua_spend
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber((ua_ads_revenue_d30_eur + ua_inapps_revenue_d30_eur) / ua_spend)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd0ErrorRateAvg(params) {
  let ua_total_pred_variance_d0_360_eur = 0
  let ua_total_pred_d0_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d0_360_eur += child.data.ua_total_pred_variance_d0_360_eur
    ua_total_pred_d0_360_eur += child.data.ua_total_pred_d0_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d0_360_eur)) / ua_total_pred_d0_360_eur)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd3ErrorRateAvg(params) {
  let ua_total_pred_variance_d3_360_eur = 0
  let ua_total_pred_d3_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d3_360_eur += child.data.ua_total_pred_variance_d3_360_eur
    ua_total_pred_d3_360_eur += child.data.ua_total_pred_d3_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d3_360_eur)) / ua_total_pred_d3_360_eur)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd7ErrorRateAvg(params) {
  let ua_total_pred_variance_d7_360_eur = 0
  let ua_total_pred_d7_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d7_360_eur += child.data.ua_total_pred_variance_d7_360_eur
    ua_total_pred_d7_360_eur += child.data.ua_total_pred_d7_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d7_360_eur)) / ua_total_pred_d7_360_eur)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd10ErrorRateAvg(params) {
  let ua_total_pred_variance_d10_360_eur = 0
  let ua_total_pred_d10_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d10_360_eur += child.data.ua_total_pred_variance_d10_360_eur
    ua_total_pred_d10_360_eur += child.data.ua_total_pred_d10_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d10_360_eur)) / ua_total_pred_d10_360_eur)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd20ErrorRateAvg(params) {
  let ua_total_pred_variance_d20_360_eur = 0
  let ua_total_pred_d20_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d20_360_eur += child.data.ua_total_pred_variance_d20_360_eur
    ua_total_pred_d20_360_eur += child.data.ua_total_pred_d20_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 21) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d20_360_eur)) / ua_total_pred_d20_360_eur)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd30ErrorRateAvg(params) {
  let ua_total_pred_variance_d30_360_eur = 0
  let ua_total_pred_d30_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d30_360_eur += child.data.ua_total_pred_variance_d30_360_eur
    ua_total_pred_d30_360_eur += child.data.ua_total_pred_d30_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d30_360_eur)) / ua_total_pred_d30_360_eur)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd40ErrorRateAvg(params) {
  let ua_total_pred_variance_d40_360_eur = 0
  let ua_total_pred_d40_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d40_360_eur += child.data.ua_total_pred_variance_d40_360_eur
    ua_total_pred_d40_360_eur += child.data.ua_total_pred_d40_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 41) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d40_360_eur)) / ua_total_pred_d40_360_eur)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd0ErrorMarginAvg(params) {
  let ua_total_pred_variance_d0_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d0_360_eur += child.data.ua_total_pred_variance_d0_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d0_360_eur)) / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd3ErrorMarginAvg(params) {
  let ua_total_pred_variance_d3_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d3_360_eur += child.data.ua_total_pred_variance_d3_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d3_360_eur)) / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd7ErrorMarginAvg(params) {
  let ua_total_pred_variance_d7_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d7_360_eur += child.data.ua_total_pred_variance_d7_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d7_360_eur)) / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd10ErrorMarginAvg(params) {
  let ua_total_pred_variance_d10_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d10_360_eur += child.data.ua_total_pred_variance_d10_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d10_360_eur)) / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd20ErrorMarginAvg(params) {
  let ua_total_pred_variance_d20_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d20_360_eur += child.data.ua_total_pred_variance_d20_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 21) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d20_360_eur)) / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd30ErrorMarginAvg(params) {
  let ua_total_pred_variance_d30_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d30_360_eur += child.data.ua_total_pred_variance_d30_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d30_360_eur)) / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaEltvd40ErrorMarginAvg(params) {
  let ua_total_pred_variance_d40_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_variance_d40_360_eur += child.data.ua_total_pred_variance_d40_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 41) {
    return null
  }
  return cleanNumber((1.96 * Math.sqrt(ua_total_pred_variance_d40_360_eur)) / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuInappsPredd0360Avg(params) {
  let ua_total_inapps_pred_d0_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d0_360_eur += child.data.ua_total_inapps_pred_d0_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d0_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuInappsPredd3360Avg(params) {
  let ua_total_inapps_pred_d3_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d3_360_eur += child.data.ua_total_inapps_pred_d3_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d3_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuInappsPredd7360Avg(params) {
  let ua_total_inapps_pred_d7_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d7_360_eur += child.data.ua_total_inapps_pred_d7_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d7_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuInappsPredd10360Avg(params) {
  let ua_total_inapps_pred_d10_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d10_360_eur += child.data.ua_total_inapps_pred_d10_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d10_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuInappsPredd20360Avg(params) {
  let ua_total_inapps_pred_d20_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d20_360_eur += child.data.ua_total_inapps_pred_d20_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 21) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d20_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuInappsPredd30360Avg(params) {
  let ua_total_inapps_pred_d30_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d30_360_eur += child.data.ua_total_inapps_pred_d30_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d30_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuInappsPredd40360Avg(params) {
  let ua_total_inapps_pred_d40_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_inapps_pred_d40_360_eur += child.data.ua_total_inapps_pred_d40_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 41) {
    return null
  }
  return cleanNumber(ua_total_inapps_pred_d40_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuAdsPredd0360Avg(params) {
  let ua_total_ads_pred_d0_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d0_360_eur += child.data.ua_total_ads_pred_d0_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d0_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuAdsPredd3360Avg(params) {
  let ua_total_ads_pred_d3_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d3_360_eur += child.data.ua_total_ads_pred_d3_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d3_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuAdsPredd7360Avg(params) {
  let ua_total_ads_pred_d7_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d7_360_eur += child.data.ua_total_ads_pred_d7_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d7_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuAdsPredd10360Avg(params) {
  let ua_total_ads_pred_d10_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d10_360_eur += child.data.ua_total_ads_pred_d10_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d10_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuAdsPredd20360Avg(params) {
  let ua_total_ads_pred_d20_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d20_360_eur += child.data.ua_total_ads_pred_d20_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 21) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d20_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuAdsPredd30360Avg(params) {
  let ua_total_ads_pred_d30_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d30_360_eur += child.data.ua_total_ads_pred_d30_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d30_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuAdsPredd40360Avg(params) {
  let ua_total_ads_pred_d40_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_ads_pred_d40_360_eur += child.data.ua_total_ads_pred_d40_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 41) {
    return null
  }
  return cleanNumber(ua_total_ads_pred_d40_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuPredd0360Avg(params) {
  let ua_total_pred_d0_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d0_360_eur += child.data.ua_total_pred_d0_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 1) {
    return null
  }
  return cleanNumber(ua_total_pred_d0_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuPredd3360Avg(params) {
  let ua_total_pred_d3_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d3_360_eur += child.data.ua_total_pred_d3_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 4) {
    return null
  }
  return cleanNumber(ua_total_pred_d3_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuPredd7360Avg(params) {
  let ua_total_pred_d7_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d7_360_eur += child.data.ua_total_pred_d7_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 8) {
    return null
  }
  return cleanNumber(ua_total_pred_d7_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuPredd10360Avg(params) {
  let ua_total_pred_d10_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d10_360_eur += child.data.ua_total_pred_d10_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 11) {
    return null
  }
  return cleanNumber(ua_total_pred_d10_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuPredd20360Avg(params) {
  let ua_total_pred_d20_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d20_360_eur += child.data.ua_total_pred_d20_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 21) {
    return null
  }
  return cleanNumber(ua_total_pred_d20_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuPredd30360Avg(params) {
  let ua_total_pred_d30_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d30_360_eur += child.data.ua_total_pred_d30_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 31) {
    return null
  }
  return cleanNumber(ua_total_pred_d30_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function uaArpuPredd40360Avg(params) {
  let ua_total_pred_d40_360_eur = 0
  let ua_installs = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_total_pred_d40_360_eur += child.data.ua_total_pred_d40_360_eur
    ua_installs += child.data.ua_installs
    maxDai = Math.min(maxDai, child.data.max_dai)
  })
  if (maxDai < 41) {
    return null
  }
  return cleanNumber(ua_total_pred_d40_360_eur / ua_installs)
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function hintAvg(params) {
  let ua_spend = 0
  let ua_installs = 0
  let mwm_installs = 0
  let ua_total_pred_dmax_360_eur = 0
  let ua_total_pred_variance_dmax_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_spend += child.data.ua_spend
    ua_installs += child.data.ua_installs
    mwm_installs += child.data.mwm_installs
    ua_total_pred_dmax_360_eur += child.data.ua_total_pred_dmax_360_eur
    ua_total_pred_variance_dmax_360_eur += child.data.ua_total_pred_variance_dmax_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })

  if (ua_spend == null || ua_installs == null) {
    return null
  }
  if (ua_spend <= 0 || ua_installs <= 0) {
    return null
  }

  if (mwm_installs < 100) {
    return 'empty'
  }
  if (maxDai < 11) {
    return 'wait'
  }

  const predLTVPerUser = ua_total_pred_dmax_360_eur / ua_installs
  const eLTVErrorMarginPerUser = (1.96 * Math.sqrt(ua_total_pred_variance_dmax_360_eur)) / ua_installs
  const cpi = ua_spend / ua_installs
  if (predLTVPerUser <= 0) {
    return ''
  }

  if (predLTVPerUser + eLTVErrorMarginPerUser < cpi) {
    return 'rip'
  } else if (predLTVPerUser - eLTVErrorMarginPerUser > cpi) {
    return 'top'
  } else if (eLTVErrorMarginPerUser / predLTVPerUser > 0.5) {
    return 'warning'
  }
  return ''
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function breakevenProbabilityAvg(params) {
  let ua_spend = 0
  let ua_installs = 0
  let mwm_installs = 0
  let ua_total_pred_dmax_360_eur = 0
  let ua_total_pred_variance_dmax_360_eur = 0
  let maxDai = 100000

  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_spend += child.data.ua_spend
    ua_installs += child.data.ua_installs
    mwm_installs += child.data.mwm_installs
    ua_total_pred_dmax_360_eur += child.data.ua_total_pred_dmax_360_eur
    ua_total_pred_variance_dmax_360_eur += child.data.ua_total_pred_variance_dmax_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })

  if (ua_spend == null || ua_installs == null) {
    return null
  }
  if (ua_spend <= 0 || ua_installs <= 0) {
    return null
  }

  if (mwm_installs < 100) {
    return 'empty'
  }
  if (maxDai < 11) {
    return 'wait'
  }

  const predLTVPerUser = ua_total_pred_dmax_360_eur / ua_installs
  const eLTVErrorMarginPerUser = (1.96 * Math.sqrt(ua_total_pred_variance_dmax_360_eur)) / ua_installs
  const cpi = ua_spend / ua_installs

  if (eLTVErrorMarginPerUser <= 0) {
    return -1
  }

  const sigma = eLTVErrorMarginPerUser / 1.96
  const delta = predLTVPerUser - cpi
  const z0 = delta / sigma
  const zScore = [computeZscore(z0)]

  params.breakeven_probability = zScore

  return zScore
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function marginMinus10ProbabilityAvg(params) {
  let ua_spend = 0
  let ua_installs = 0
  let mwm_installs = 0
  let ua_total_pred_dmax_360_eur = 0
  let ua_total_pred_variance_dmax_360_eur = 0
  let maxDai = 100000

  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_spend += child.data.ua_spend
    ua_installs += child.data.ua_installs
    mwm_installs += child.data.mwm_installs
    ua_total_pred_dmax_360_eur += child.data.ua_total_pred_dmax_360_eur
    ua_total_pred_variance_dmax_360_eur += child.data.ua_total_pred_variance_dmax_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })

  if (ua_spend == null || ua_installs == null) {
    return null
  }
  if (ua_spend <= 0 || ua_installs <= 0) {
    return null
  }

  if (mwm_installs < 100) {
    return 'empty'
  }
  if (maxDai < 11) {
    return 'wait'
  }

  const predLTVPerUser = ua_total_pred_dmax_360_eur / ua_installs
  const eLTVErrorMarginPerUser = (1.96 * Math.sqrt(ua_total_pred_variance_dmax_360_eur)) / ua_installs
  const cpi = (ua_spend / ua_installs) * 0.9

  if (eLTVErrorMarginPerUser <= 0) {
    return -1
  }

  const sigma = eLTVErrorMarginPerUser / 1.96
  const delta = predLTVPerUser - cpi
  const z0 = delta / sigma
  const zScore = [1 - computeZscore(z0)]

  params.margin_minus_10_probability = zScore

  return zScore
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function margin10ProbabilityAvg(params) {
  let ua_spend = 0
  let ua_installs = 0
  let mwm_installs = 0
  let ua_total_pred_dmax_360_eur = 0
  let ua_total_pred_variance_dmax_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_spend += child.data.ua_spend
    ua_installs += child.data.ua_installs
    mwm_installs += child.data.mwm_installs
    ua_total_pred_dmax_360_eur += child.data.ua_total_pred_dmax_360_eur
    ua_total_pred_variance_dmax_360_eur += child.data.ua_total_pred_variance_dmax_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })

  if (ua_spend == null || ua_installs == null) {
    return null
  }
  if (ua_spend <= 0 || ua_installs <= 0) {
    return null
  }

  if (mwm_installs < 100) {
    return 'empty'
  }
  if (maxDai < 11) {
    return 'wait'
  }

  const predLTVPerUser = ua_total_pred_dmax_360_eur / ua_installs
  const eLTVErrorMarginPerUser = (1.96 * Math.sqrt(ua_total_pred_variance_dmax_360_eur)) / ua_installs
  const cpi = (ua_spend / ua_installs) * 1.1
  if (eLTVErrorMarginPerUser <= 0) {
    return -1
  }

  const sigma = eLTVErrorMarginPerUser / 1.96
  const delta = predLTVPerUser - cpi
  const z0 = delta / sigma
  const zScore = [computeZscore(z0)]
  params.margin_10_probability = zScore
  return zScore
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function margin25ProbabilityAvg(params) {
  let ua_spend = 0
  let ua_installs = 0
  let mwm_installs = 0
  let ua_total_pred_dmax_360_eur = 0
  let ua_total_pred_variance_dmax_360_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_spend += child.data.ua_spend
    ua_installs += child.data.ua_installs
    mwm_installs += child.data.mwm_installs
    ua_total_pred_dmax_360_eur += child.data.ua_total_pred_dmax_360_eur
    ua_total_pred_variance_dmax_360_eur += child.data.ua_total_pred_variance_dmax_360_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })

  if (ua_spend == null || ua_installs == null) {
    return null
  }
  if (ua_spend <= 0 || ua_installs <= 0) {
    return null
  }

  if (mwm_installs < 100) {
    return 'empty'
  }
  if (maxDai < 11) {
    return 'wait'
  }

  const predLTVPerUser = ua_total_pred_dmax_360_eur / ua_installs
  const eLTVErrorMarginPerUser = (1.96 * Math.sqrt(ua_total_pred_variance_dmax_360_eur)) / ua_installs
  const cpi = (ua_spend / ua_installs) * 1.25
  if (eLTVErrorMarginPerUser <= 0) {
    return -1
  }

  const sigma = eLTVErrorMarginPerUser / 1.96
  const delta = predLTVPerUser - cpi
  const z0 = delta / sigma
  const zScore = [computeZscore(z0)]
  params.margin_25_probability = zScore
  return zScore
}

// @ts-expect-error implicit any
// eslint-disable-next-line
function arpuVsLtvAvg(params) {
  let ua_installs = 0
  let ua_total_pred_dmax_360_eur = 0
  let ua_inapps_revenue_total_eur = 0
  let ua_ads_revenue_total_eur = 0
  let maxDai = 100000
  params.rowNode.allLeafChildren.forEach((child: any) => {
    ua_installs += child.data.ua_installs
    ua_total_pred_dmax_360_eur += child.data.ua_total_pred_dmax_360_eur
    ua_inapps_revenue_total_eur += child.data.ua_inapps_revenue_total_eur
    ua_ads_revenue_total_eur += child.data.ua_ads_revenue_total_eur
    maxDai = Math.min(maxDai, child.data.max_dai)
  })

  const predLTVPerUser = ua_total_pred_dmax_360_eur / ua_installs
  const arpu = (ua_ads_revenue_total_eur + ua_inapps_revenue_total_eur) / ua_installs

  let result = 'legit'
  if (arpu > predLTVPerUser) {
    result = 'warning'
  }
  params.arpu_vs_ltv = result
  return result
}

export default {
  arpuVsLtvAvg,
  breakevenProbabilityAvg,
  costPerFreeTrialD0Avg,
  costPerFreeTrialD10Avg,
  costPerFreeTrialLifetimeAvg,
  costPerPayingUserD0Avg,
  costPerPayingUserD10Avg,
  costPerPayingUserLifetimeAvg,
  costPerSubscriberD0Avg,
  costPerSubscriberD10Avg,
  costPerSubscriberLifetimeAvg,
  cpiAvg,
  cpmAvg,
  ctrAvg,
  cvrAvg,
  extrapolationAvg,
  freeTrialPerInstallD0Avg,
  freeTrialPerInstallD10Avg,
  freeTrialPerInstallLifetimeAvg,
  hintAvg,
  margin10ProbabilityAvg,
  margin25ProbabilityAvg,
  marginMinus10ProbabilityAvg,
  mwmAdsArpud0Avg,
  mwmAdsArpud10Avg,
  mwmAdsArpud180Avg,
  mwmAdsArpud1Avg,
  mwmAdsArpud30Avg,
  mwmAdsArpud360Avg,
  mwmAdsArpud3Avg,
  mwmAdsArpud7Avg,
  mwmAdsArpudTotalAvg,
  mwmAdsEltvd0Avg,
  mwmAdsEltvd10Avg,
  mwmAdsEltvd30Avg,
  mwmAdsEltvd3Avg,
  mwmAdsEltvd7Avg,
  mwmArpuAvg,
  mwmArpud0Avg,
  mwmArpud10Avg,
  mwmArpud180Avg,
  mwmArpud1Avg,
  mwmArpud30Avg,
  mwmArpud360Avg,
  mwmArpud3Avg,
  mwmArpud7Avg,
  mwmEltvPerFreeTriald10Avg,
  mwmEltvPerPayingd10Avg,
  mwmEltvPerSubscriberd10Avg,
  mwmEltvd0Avg,
  mwmEltvd10Avg,
  mwmEltvd30Avg,
  mwmEltvd3Avg,
  mwmEltvd7Avg,
  mwmIapArpud0Avg,
  mwmIapArpud10Avg,
  mwmIapArpud180Avg,
  mwmIapArpud1Avg,
  mwmIapArpud30Avg,
  mwmIapArpud360Avg,
  mwmIapArpud3Avg,
  mwmIapArpud7Avg,
  mwmIapArpudTotalAvg,
  mwmIapEltvd0Avg,
  mwmIapEltvd10Avg,
  mwmIapEltvd30Avg,
  mwmIapEltvd3Avg,
  mwmIapEltvd7Avg,
  mwmOnboardingcompletedAvg,
  mwmRoipercentd0Avg,
  mwmRoipercentd10Avg,
  mwmRoipercentd20Avg,
  mwmRoipercentd30Avg,
  mwmRoipercentd3Avg,
  mwmRoipercentd7Avg,
  mwmroipercentAvg,
  payingUserPerInstallD0Avg,
  payingUserPerInstallD10Avg,
  payingUserPerInstallLifetimeAvg,
  retentiond1Avg,
  retentiond30Avg,
  retentiond3Avg,
  retentiond7Avg,
  revenuePerFreeTrialLifetimeAvg,
  revenuePerPayingUserLifetimeAvg,
  revenuePerSubscriberLifetimeAvg,
  subscriberPerInstallD0Avg,
  subscriberPerInstallD10Avg,
  subscriberPerInstallLifetimeAvg,
  uaAdsEltvd0Avg,
  uaAdsEltvd10Avg,
  uaAdsEltvd30Avg,
  uaAdsEltvd3Avg,
  uaAdsEltvd7Avg,
  uaArpuAdsPredd0360Avg,
  uaArpuAdsPredd10360Avg,
  uaArpuAdsPredd20360Avg,
  uaArpuAdsPredd30360Avg,
  uaArpuAdsPredd3360Avg,
  uaArpuAdsPredd40360Avg,
  uaArpuAdsPredd7360Avg,
  uaArpuInappsPredd0360Avg,
  uaArpuInappsPredd10360Avg,
  uaArpuInappsPredd20360Avg,
  uaArpuInappsPredd30360Avg,
  uaArpuInappsPredd3360Avg,
  uaArpuInappsPredd40360Avg,
  uaArpuInappsPredd7360Avg,
  uaArpuPredd0360Avg,
  uaArpuPredd10360Avg,
  uaArpuPredd20360Avg,
  uaArpuPredd30360Avg,
  uaArpuPredd3360Avg,
  uaArpuPredd40360Avg,
  uaArpuPredd7360Avg,
  uaEltvd0Avg,
  uaEltvd0ErrorMarginAvg,
  uaEltvd0ErrorRateAvg,
  uaEltvd10Avg,
  uaEltvd10ErrorMarginAvg,
  uaEltvd10ErrorRateAvg,
  uaEltvd20ErrorMarginAvg,
  uaEltvd20ErrorRateAvg,
  uaEltvd30Avg,
  uaEltvd30ErrorMarginAvg,
  uaEltvd30ErrorRateAvg,
  uaEltvd3Avg,
  uaEltvd3ErrorMarginAvg,
  uaEltvd3ErrorRateAvg,
  uaEltvd40ErrorMarginAvg,
  uaEltvd40ErrorRateAvg,
  uaEltvd7Avg,
  uaEltvd7ErrorMarginAvg,
  uaEltvd7ErrorRateAvg,
  uaEroipercentd0Avg,
  uaEroipercentd10Avg,
  uaEroipercentd30Avg,
  uaEroipercentd3Avg,
  uaEroipercentd7Avg,
  uaIapEltvSovd0Avg,
  uaIapEltvSovd10Avg,
  uaIapEltvSovd30Avg,
  uaIapEltvSovd3Avg,
  uaIapEltvSovd7Avg,
  uaIapEltvd0Avg,
  uaIapEltvd10Avg,
  uaIapEltvd30Avg,
  uaIapEltvd3Avg,
  uaIapEltvd7Avg,
  uaRoipercentd0Avg,
  uaRoipercentd10Avg,
  uaRoipercentd20Avg,
  uaRoipercentd30Avg,
  uaRoipercentd3Avg,
  uaRoipercentd7Avg,
  uaroipercentAvg,
}
